import { get, put } from '@/services/http';
import { SupplierModel } from '@/models/supplier';
import { supplierData, supplierProducts, buyingListData, supplierMetricsHistory } from '@/mock/supplier-data';
import List from './list';

export class SupplierList extends List<SupplierModel> {

  /**
   * @method fetch
   * @description Fetches suppliers from the API and maps the data to the collection.
   * @param {Object} options - The options for the fetch operation, can be null.
   * @param {number} options.page - The page number to fetch.
   * @param {number} options.limit - The number of items per page.
   * @returns {Promise<number>} The total number of items in the collection.
   */
  public async fetch(options: { page?: number, limit?: number, search?: string, sortBy?: string, sortDesc?: boolean } = {}): Promise<any> {
    // fetch data from api
    options.page = options.page || 1;
    options.limit = options.limit || 1000;
    const response: any = await get('/suppliers', options);
    this.mapData(response.data);
    return response.data;
  }

  public mapData(data: any) {

    // Clear existing items
    this.items = [];
    if (data.suppliers) {
      for (const supplier of data.suppliers) {
        const supplierModel = new SupplierModel(supplier);
        this.add(supplierModel);
      }
    }
  }

  public async save() {
    try {
      // In mock mode, just log the save operation
      return true;
    } catch (e) {
      return false;
    }
  }

  public countActiveSuppliers(): number {
    return this.items.filter((supplier) =>
      supplier.status === 'ACTIVE',
    ).length;
  }

  public getSuppliersByMetricThreshold(metricLabel: string, threshold: number): SupplierModel[] {
    return this.items.filter((supplier) => {
      const metric = supplier.summaryMetrics.find((m) => m.label === metricLabel);
      if (!metric) { return false; }
      const value = parseFloat(String(metric.value));
      return !isNaN(value) && value >= threshold;
    });
  }
}
